import type { ReactElement } from 'react';

interface SwitchProps {
    checked: boolean;
    onChange: (next: boolean) => void;
    label?: string;
    disabled?: boolean;
    testId?: string;
}

export function Switch({ checked, onChange, label, disabled, testId }: SwitchProps): ReactElement {
    return (
        <label className="inline-flex cursor-pointer items-center gap-2">
            <button
                type="button"
                role="switch"
                aria-checked={checked}
                disabled={disabled}
                onClick={() => onChange(!checked)}
                data-testid={testId}
                className={`relative inline-flex h-5 w-9 items-center rounded-full transition disabled:opacity-50 ${
                    checked ? 'bg-gray-900' : 'bg-gray-300'
                }`}
            >
                <span
                    className={`inline-block h-4 w-4 transform rounded-full bg-white transition ${
                        checked ? 'translate-x-4' : 'translate-x-0.5'
                    }`}
                />
            </button>
            {label && <span className="text-sm text-gray-700">{label}</span>}
        </label>
    );
}
